import * as Sentry from "@sentry/react"

const scrubPhone = (url: string) => url.replace(/([?&]phone=)[^&]*/, "$1[Filtered]")

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_VERSION,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "development",
    integrations: [Sentry.browserTracingIntegration(), Sentry.httpClientIntegration()],
    tracesSampleRate: 0.4,
    // Our self-hosted Sentry drops v11's default streamed spans; send classic transactions instead
    traceLifecycle: "static",
    // Login sends ?phone=... — keep it out of tracing spans (beforeSend/beforeBreadcrumb cover events and breadcrumbs)
    dataCollection: { urlQueryParams: { deny: ["phone"] } },
    beforeSend(event) {
        if (event.request?.url) event.request.url = scrubPhone(event.request.url)
        return event
    },
    beforeBreadcrumb(breadcrumb) {
        if (breadcrumb.data?.url) breadcrumb.data.url = scrubPhone(String(breadcrumb.data.url))
        return breadcrumb
    },
})
